import type { SVGProps } from "react";

export const StatusCircleQuarter = ({
  width = 12,
  height = 12,
  ...props
}: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_619_9106)">
        <circle cx="6" cy="6" r="5.5" stroke="currentColor" />
        <path
          d="M10 6C10 5.47471 9.89654 4.95457 9.69552 4.46927C9.4945 3.98396 9.19986 3.54301 8.82843 3.17157C8.45699 2.80014 8.01604 2.5055 7.53073 2.30448C7.04543 2.10346 6.52529 2 6 2L6 6H10Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_619_9106">
          <rect width="12" height="12" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};
